import checkAPI from "@/api/check";

const state = {
  checks: [],
  cashAmount: [],
  checkToSend: null,
  checkSum: 0,
  totalSum: 0,
};

const mutations = {
  searchChecksStart(state) {
    state.checks = [];
    state.totalSum = 0;
  },
  searchChecksSuccess(state, payloads) {
    state.checks = payloads["hydra:member"];
    state.cashAmount = payloads["app:cashAmount"];
    let sum = 0;
    payloads["hydra:member"].forEach((item) => {
      sum += parseFloat(item.amount);
    });
    state.totalSum = sum.toFixed(2);
  },
  searchChecksFailure(state) {
    state.checks = [];
    state.totalSum = 0;
  },
  clearCheckToSend(state) {
    state.checkToSend = null;
    state.checkSum = 0;
  },
  fillCheckToSend(state, payload) {
    state.checkToSend = payload;
  },
  updateCheckSum(state, payload) {
    state.checkSum = payload;
  },
  synchronizeCheck(state, checkId) {
    state.checks.forEach(function (item, index) {
      if (item.id === checkId) {
        item.isSynchronized = true;
        state.checks.splice(index, 1, item);
      }
    });
  },
};

const getters = {
  checks(state) {
    return state.checks;
  },
  cashAmount(state) {
    return state.cashAmount;
  },
  checkToSend(state) {
    return state.checkToSend;
  },
  checkSum(state) {
    return state.checkSum;
  },
  totalSum(state) {
    return state.totalSum;
  },
};

const actions = {
  synchronize_check(context, payload) {
    return new Promise((resolve, reject) => {
      checkAPI
        .synchronize_check(payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((result) => {
          reject(result);
        });
    });
  },
  get_driver_pko(context, payload) {
    context.commit("searchChecksStart");
    return new Promise((resolve) => {
      checkAPI
        .get_driver_pko(payload.start, payload.end)
        .then((response) => {
          context.commit("searchChecksSuccess", response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit("searchChecksFailure", result);
        });
    });
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
